import { render, staticRenderFns } from "./SimpleTextAreaInput.vue?vue&type=template&id=0fffaa18&"
import script from "./SimpleTextAreaInput.vue?vue&type=script&lang=js&"
export * from "./SimpleTextAreaInput.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTextAreaInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports